// extracted by mini-css-extract-plugin
module.exports = {"SocialLinks":"SocialLinks_SocialLinks__3mYOJ","SocialLink":"SocialLinks_SocialLink__2c0TI","Bg":"SocialLinks_Bg__1jTc6"};